import workspaceQuery from '../../queries/system/SystemSmtpLogWorkspaceQuery.graphql';
import listQuery from '../../queries/system/SystemSmtpLogListQuery.graphql';
import instanceQuery from '../../queries/system/SystemSmtpLogQuery.graphql';
import defaultQuery from '../../queries/system/SystemSmtpLogDefault.graphql';
import mutationQuery from '../../mutations/system/SystemSmtpLogMutation.graphql';
import fragment from '../../fragments/system/SystemSmtpLogFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { workspace as actions } from '../../../actions/system/SmtpLogWorkspaceAction';
import { EntityType } from '../../../@types/entityTypes';

const SystemSmtpLog: EntityType = {
  type: 'SmtpLog',
  title: 'SMTP Log',
  formTitle: 'SMTP Log',
  formUrl: '/System/SmtpLog/Details/',
  workspaceUrl: '/System/SmtpLog/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'subject',
  },
  fragment,
  operations: ALLOW_VIEW,
  actions: actions,
  screenReference: 'SMTP_LOG',
};

export default SystemSmtpLog;
